import * as Common from "../../commons/common"

export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string
  passing_score_103: string
  passing_score_104: string
  sub_passing_score_103: string
  sub_passing_score_104: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
    this.passing_score_103 = sumupGroup.passing_score_103;
    this.passing_score_104 = sumupGroup.passing_score_104;
    this.sub_passing_score_103 = sumupGroup.sub_passing_score_103;
    this.sub_passing_score_104 = sumupGroup.sub_passing_score_104;
  }
}

export class RankResult {
  practice_examinee_id: number
  room_name: string
  student_no_character: string
  student_name: string
  curriculumResults: CurriculumResult[]
  cram_school_name: string
  cram_room_name: string
  applied_type: number
  rowObject: any = {}
  colCount: number
  scoreKeys: number[] = []
  rankKeys: number[] = []
  stdScoreKeys: number[] = []
  passing_state_103: number
  passing_state_104: number
  passing_state_fixed: number
  result_published_cache: boolean

  constructor(rankResult: any){
    this.practice_examinee_id = rankResult.practice_examinee_id;
    this.room_name = rankResult.room_name;
    this.student_no_character = rankResult.student_no_character;
    this.student_name = rankResult.student_name;
    this.curriculumResults = rankResult.curriculum_results.map((x: any) => new CurriculumResult(x));
    this.cram_school_name = rankResult.cram_school_name;
    this.cram_room_name = rankResult.cram_room_name;
    this.applied_type = rankResult.applied_type;
    this.passing_state_103 = rankResult.passing_state_103;
    this.passing_state_104 = rankResult.passing_state_104;
    this.passing_state_fixed = rankResult.passing_state_fixed;
    this.result_published_cache = rankResult.result_published;

    let i = 0;
    this.rowObject["student_no_character"] = this.student_no_character;
    i++;
    this.rowObject["student_name"] = this.student_name;
    i++;
    this.rowObject["cram_school_name"] = this.cram_school_name;
    i++;
    this.rowObject["cram_room_name"] = this.cram_room_name;
    i++;
    this.rowObject["applied_type_name"] = Common.GetAppliedTypeNameByCode(this.applied_type);
    this.rowObject["applied_type"] = this.applied_type;
    i++;
    this.rowObject["practice_examinee_id"] = this.practice_examinee_id;
    i++;
    for(const curriculumResult of this.curriculumResults){
      this.scoreKeys.push(i);
      this.rowObject[i++] = curriculumResult.score;
      this.rankKeys.push(i);
      this.rowObject[i++] = curriculumResult.rank;
      this.stdScoreKeys.push(i);
      this.rowObject[i++] = curriculumResult.std_score;
    }
    this.rowObject["passing_state_104"] = getPassingText(this.passing_state_104);
    i++;
    this.rowObject["passing_state_103"] = getPassingText(this.passing_state_103);
    i++;
    this.rowObject["passing_state_fixed"] = getPassingTextFixed(this.passing_state_fixed);
    i++;
    this.rowObject["result_published"] = rankResult.result_published;
    i++;
    this.rowObject["isSelected"] = false;
    i++;

    this.colCount = i;
  }
}

export const getPassingText = (value: number) => {
  if(value == null){
    return "-"
  }else if(value == Common.PassingStateEnum.Fail){
    return "×";
  }else if(value == Common.PassingStateEnum.Sub){
    return "△";
  }else if(value == Common.PassingStateEnum.Pass){
    return "○";
  }else{
    return "-";
  }
}

export const getPassingTextFixed = (value: number) => {
  if(value == null){
    return "-"
  }else if(value == Common.PassingStateEnum.Fail){
    return "不合格";
  }else if(value == Common.PassingStateEnum.Sub){
    return "補欠合格";
  }else if(value == Common.PassingStateEnum.Pass){
    return "合格";
  }else{
    return "-";
  }
}

export class CurriculumResult {
  score: string
  rank: string
  std_score: string
  curriculum_id: number
  is_absent: boolean

  constructor(curriculumResult: any){
    this.score = curriculumResult.score;
    this.rank = curriculumResult. rank;
    this.std_score = curriculumResult.std_score.toFixed(1);
    this.curriculum_id = curriculumResult.curriculum_id;
    this.is_absent = curriculumResult.is_absent;
  }
}

export class SearchCondtion {
  student_name: string = ""
  student_no_character: string = ""
  applied_type: number = null
}

export class AverageResult {
  curriculum_name: string
  avg_score: number
 
  constructor(averageResult: any){
    this.curriculum_name = averageResult.curriculum_name;
    this.avg_score = averageResult.avg_score;
  }
}

export class Assessment {
  value: string
  std_score: number
  comment: string

  constructor(assessment: any){
    this.value = assessment.value;
    this.std_score = assessment.std_score;
    this.comment = assessment.comment;
  }
}